// ============================================
// ConverseTech Frontend - Consent Modal
// ============================================

import { Shield } from 'lucide-react';

interface ConsentModalProps {
  onAccept: () => void;
  onDecline: () => void;
}

export default function ConsentModal({ onAccept, onDecline }: ConsentModalProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div data-testid="consent-modal" className="bg-white rounded-xl p-6 max-w-md mx-4 shadow-xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-primary-100 text-primary-600 rounded-full flex items-center justify-center">
            <Shield className="w-5 h-5" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900">Privacy Consent</h2>
        </div>

        <div data-testid="consent-text" className="text-gray-600 mb-6 space-y-3">
          <p>
            To provide AI coaching, ConverseTech needs to process your voice in real-time. Here's what we do:
          </p>
          <ul className="list-disc list-inside space-y-1 text-sm">
            <li>Transcribe your speech to provide feedback</li>
            <li>Calculate performance metrics</li>
            <li>Send audio to our AI partner (Google Gemini) for processing</li>
            <li>Optionally save recordings for your review (you can enable this in settings)</li>
          </ul>
          <p className="text-sm">
            Your data is never sold and is only used to improve your training experience.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            data-testid="consent-decline-button"
            onClick={onDecline}
            className="flex-1 py-3 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 font-medium transition-colors"
          >
            Not Now
          </button>
          <button
            data-testid="consent-accept-button"
            onClick={onAccept}
            className="flex-1 py-3 bg-primary-600 hover:bg-primary-700 rounded-lg text-white font-medium transition-colors"
          >
            I Agree
          </button>
        </div>
      </div>
    </div>
  );
}
